var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-wrap"},[_c('div',{staticClass:"loading"},[_c('div',{staticClass:"loader"}),_c('b',[_vm._v(_vm._s(_vm.keyword))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }